import { useEffect, useRef, useState } from 'react'
import { orderBy } from 'lodash'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { SortDirectionEnum } from '../../../../../core/enums/sort-direction.enum'
import { WM_COLUMN_KEY_POSITION } from '../../../../../core/config/reports/wm-report-table.config'
import GlLoader from '../../../../share/GlLoader'
import AnalyticDetailsTableHeader from './AnalyticDetailsTableHeader'
import AnalyticDetailsTableBody from './AnaliticDetailsTableBody'
import { AuthorMirrorAuthorInterface } from '../../../../../core/interface/report/author-mirror-author.interface'

const AnalyticDetailsTable = ({
  isLoadingReloadOutput,
  authorsOutput,
  handleAuthorSelected,
  authorDetailsSelected,
  authorIdHovered,
}: {
  isLoadingReloadOutput: boolean
  authorsOutput: AuthorMirrorAuthorInterface[]
  handleAuthorSelected: (author: AuthorMirrorAuthorInterface) => void
  authorDetailsSelected: AuthorMirrorAuthorInterface | null
  authorIdHovered: string | null
}) => {
  const refContainerScroll = useRef<any>(null)
  const [sortDetail, setSortDetails] = useState<{
    sortDirection: SortDirectionEnum
    key: string
  }>({ sortDirection: SortDirectionEnum.ASC, key: WM_COLUMN_KEY_POSITION })

  const sortedAuthors = orderBy(
    authorsOutput,
    [sortDetail.key],
    [sortDetail.sortDirection === SortDirectionEnum.ASC ? 'asc' : 'desc'],
  )

  useEffect(() => {
    if (refContainerScroll && authorIdHovered) {
      const element = document.getElementById(`line-table-${authorIdHovered}`)
      if (element) {
        element.scrollIntoView()
      }
    }
  }, [authorIdHovered])

  return (
    <div className="flex flex-col flex-auto">
      <AnalyticDetailsTableHeader
        sortDetail={sortDetail}
        handleChangeSort={setSortDetails}
      />
      <PerfectScrollbar
        ref={refContainerScroll}
        className="flex-auto"
        style={{
          height: 0,
        }}
      >
        {(isLoadingReloadOutput && <GlLoader />) ||
          (authorsOutput && authorsOutput.length && (
            <AnalyticDetailsTableBody
              authorsOutput={sortedAuthors}
              hasSelect={!!handleAuthorSelected}
              handleAuthorSelected={handleAuthorSelected}
              authorDetailsSelected={authorDetailsSelected}
              authorIdHovered={authorIdHovered}
            />
          )) ||
          null}
      </PerfectScrollbar>
    </div>
  )
}

export default AnalyticDetailsTable
